import styled from 'styled-components';
import { getButtonAppearance } from './getAppearance';
import { buttonBase } from '../styled';
import { getButtonSize } from '../utils';
import { stretchButton } from '../utils/stretchButton';
export const FilterButton = styled.button `
  ${buttonBase};
  ${stretchButton};

  ${(props) => getButtonSize(props.size || 'xs')};
  ${(props) => getButtonAppearance(props.appearance)};
`;
